import type { ReactNode } from 'react';
import { Layout } from 'antd';
import { HeaderSlotProvider } from './HeaderSlot';
import styles from './PageShell.module.css';

const { Content } = Layout;

interface PageShellProps {
  // Меню и шапка приходят слотами: shared не знает о виджетах.
  sidebar: ReactNode;
  header: ReactNode;
  children: ReactNode;
}

export function PageShell({ sidebar, header, children }: PageShellProps) {
  return (
    // Сайдбар держит место в потоке сам — контент просто занимает остаток.
    <HeaderSlotProvider>
      <div className={styles.shell}>
        {sidebar}
        <Layout className={styles.main}>
          {header}
          <Content className={styles.content}>{children}</Content>
        </Layout>
      </div>
    </HeaderSlotProvider>
  );
}
